export interface State {
  abbr: string;
  name: string;
}

export const states: State[] = [
  {
    abbr: "",
    name: ""
  },
  {
    abbr: "AL",
    name: "Alabama"
  },
  {
    abbr: "AK",
    name: "Alaska"
  },
  {
    abbr: "AB",
    name: "Alberta"
  },
  {
    abbr: "AS",
    name: "American Samoa"
  },
  {
    abbr: "AZ",
    name: "Arizona"
  },
  {
    abbr: "AR",
    name: "Arkansas"
  },
  {
    abbr: "AA",
    name: "Armed Forces Americas"
  },
  {
    abbr: "AE",
    name: "Armed Forces Europe"
  },
  {
    abbr: "AP",
    name: "Armed Forces Pacific"
  },
  {
    abbr: "BC",
    name: "British Columbia"
  },
  {
    abbr: "CA",
    name: "California"
  },
  {
    abbr: "CO",
    name: "Colorado"
  },
  {
    abbr: "CT",
    name: "Connecticut"
  },
  {
    abbr: "DE",
    name: "Delaware"
  },
  {
    abbr: "DC",
    name: "District of Columbia"
  },
  {
    abbr: "FM",
    name: "Federated State Of Micronesia"
  },
  {
    abbr: "FL",
    name: "Florida"
  },
  {
    abbr: "GA",
    name: "Georgia"
  },
  {
    abbr: "GU",
    name: "Guam"
  },
  {
    abbr: "HI",
    name: "Hawaii"
  },
  {
    abbr: "ID",
    name: "Idaho"
  },
  {
    abbr: "IL",
    name: "Illinois"
  },
  {
    abbr: "IN",
    name: "Indiana"
  },
  {
    abbr: "IA",
    name: "Iowa"
  },
  {
    abbr: "KS",
    name: "Kansas"
  },
  {
    abbr: "KY",
    name: "Kentucky"
  },
  {
    abbr: "LA",
    name: "Louisiana"
  },
  {
    abbr: "ME",
    name: "Maine"
  },
  {
    abbr: "MB",
    name: "Manitoba"
  },
  {
    abbr: "MH",
    name: "Marshall Islands"
  },
  {
    abbr: "MD",
    name: "Maryland"
  },
  {
    abbr: "MA",
    name: "Massachusetts"
  },
  {
    abbr: "MI",
    name: "Michigan"
  },
  {
    abbr: "MN",
    name: "Minnesota"
  },
  {
    abbr: "MS",
    name: "Mississippi"
  },
  {
    abbr: "MO",
    name: "Missouri"
  },
  {
    abbr: "MT",
    name: "Montana"
  },
  {
    abbr: "NE",
    name: "Nebraska"
  },
  {
    abbr: "NV",
    name: "Nevada"
  },
  {
    abbr: "NB",
    name: "New Brunswick"
  },
  {
    abbr: "NH",
    name: "New Hampshire"
  },
  {
    abbr: "NJ",
    name: "New Jersey"
  },
  {
    abbr: "NM",
    name: "New Mexico"
  },
  {
    abbr: "NY",
    name: "New York"
  },
  {
    abbr: "NF",
    name: "Newfoundland"
  },
  {
    abbr: "NC",
    name: "North Carolina"
  },
  {
    abbr: "ND",
    name: "North Dakota"
  },
  {
    abbr: "MP",
    name: "Northern Mariana Islands"
  },
  {
    abbr: "NT",
    name: "Northwest Territories"
  },
  {
    abbr: "NS",
    name: "Nova Scotia"
  },
  {
    abbr: "NU",
    name: "Nunavut"
  },
  {
    abbr: "OH",
    name: "Ohio"
  },
  {
    abbr: "OK",
    name: "Oklahoma"
  },
  {
    abbr: "ON",
    name: "Ontario"
  },
  {
    abbr: "OR",
    name: "Oregon"
  },
  {
    abbr: "PW",
    name: "Palau"
  },
  {
    abbr: "PA",
    name: "Pennsylvania"
  },
  {
    abbr: "PE",
    name: "Prince Edward Island"
  },
  {
    abbr: "PR",
    name: "Puerto Rico"
  },
  {
    abbr: "QC",
    name: "Quebec"
  },
  {
    abbr: "RI",
    name: "Rhode Island"
  },
  {
    abbr: "SK",
    name: "Saskatchewan"
  },
  {
    abbr: "SC",
    name: "South Carolina"
  },
  {
    abbr: "SD",
    name: "South Dakota"
  },
  {
    abbr: "TN",
    name: "Tennessee"
  },
  {
    abbr: "TX",
    name: "Texas"
  },
  {
    abbr: "UT",
    name: "Utah"
  },
  {
    abbr: "VT",
    name: "Vermont"
  },
  {
    abbr: "VI",
    name: "Virgin Islands"
  },
  {
    abbr: "VA",
    name: "Virginia"
  },
  {
    abbr: "WA",
    name: "Washington"
  },
  {
    abbr: "WV",
    name: "West Virginia"
  },
  {
    abbr: "WI",
    name: "Wisconsin"
  },
  {
    abbr: "WY",
    name: "Wyoming"
  },
  {
    abbr: "YK",
    name: "Yukon"
  }
];

export default states;